/**
 * Created by pandemio on 3/22/19.
 */
import React from 'react';
import {Input, Row, Col, Label, Alert, Button} from 'reactstrap';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Validates the coupon
 */
class FormGroupCoupon extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            valid: false,
            couponError: '',
            coupon: '',
            disabled: false,
            isReadOnly: false
        }; // Default value

        if (this.props.data) {
            this.state =
            {
                coupon: this.props.data.coupon,
                disabled: this.props.disabled
            }; // Default value
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleCouponSubmit = this.handleCouponSubmit.bind(this);
        this.handleCouponRemove = this.handleCouponRemove.bind(this);
    }

    /**
     * If the props are not null, set the values
     * @param props
     */
    componentWillReceiveProps(props) {

        if (typeof props.data !== 'undefined') {
            this.setState({
                coupon: props.data.coupon,
                disabled: props.disabled
            });
        }
    }

    /**
     * Handles the coupon submition
     */
    handleCouponSubmit(){
        this.setState({
            couponError: ''
        },()=>{
            if(this.state.coupon.trim().length > 0)
            {
                let apiCalls = ApiCalls.getCouponValidate(this.state.coupon);
                apiCalls.then((data)=> {
                    if(!data.CouponValid){
                        this.setState({
                            couponError: data.CouponReason,
                            valid: false
                        },()=>{
                            this.props.updateParent(null);
                        })
                    }
                    else
                    {
                        this.setState({
                            valid: true,
                            disabled: true
                        },()=>{
                            // Update parent
                            this.props.updateParent(data.CouponPlatformId);
                        })
                    }
                });
            }
        });
    }

    handleCouponRemove(){
        this.setState({coupon: '', valid: false, disabled: false},()=>
        {
            this.props.updateParent(null);
        })
    }

    /**
     * Action when the email is changed
     * @param event
     */
    handleChange(event) {
        this.setState({coupon: event.target.value});
    }

    // Render the form group
    render() {
        return (
            <div>
                <Row>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        {
                            this.state.disabled ?
                                <Translate id="coupons.coupon"/> :
                                <Translate id="coupons.coupon-instructions"/>
                        }
                    </Col>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Row>
                            <Col xs={{size: 5}}  sm={{size: 5}} md={{size: 5}} lg={{size: 5}}>
                                <Input disabled={this.state.isReadOnly || this.state.disabled} value={this.state.coupon} type="coupon" name="coupon"
                                   id="coupon"
                                   onChange={this.handleChange}/>
                            </Col>
                            <Col xs={{size: 7}}  sm={{size: 7}} md={{size: 7}} lg={{size: 7}}>
                                {
                                    !this.state.isReadOnly && !this.state.disabled ?
                                        <Button outline color="primary" onClick={this.handleCouponSubmit}>
                                            <Translate id="coupons.submit"/>
                                        </Button> :
                                        null
                                }
                                {
                                    this.state.valid && !this.state.isReadOnly?
                                        <Button outline color="danger" onClick={this.handleCouponRemove}>
                                            <Translate id="coupons.remove"/>
                                        </Button> :
                                        null
                                }
                            </Col>
                        </Row>
                        <br/>
                        {
                            this.state.couponError.length !== 0 ?
                                <div>
                                    <Alert color="danger" isOpen={!this.state.valid}>
                                        {this.state.couponError}
                                    </Alert>
                                </div> : null
                        }
                    </Col>
                </Row>
            </div>
        )
    };
}

export default FormGroupCoupon;